<template>

  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick" ref="child" :bigType='1'></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="rightContainer">
        <div class="box1">当前部门：{{ this.CurrentDepartment.fullLabel }}</div>
        <div class="box2" v-if="editVisible">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="部门名称" prop="Name">
              <el-input v-model="ruleForm.Name"></el-input>
            </el-form-item>
            <el-form-item>

              <el-button v-if="addVisible" type="primary" @click.native="submitForm"
                :loading="addLoading">新建部门</el-button>

              <el-button v-if="addSubVisible" type="primary" @click="submitSubForm()">新建下级部门</el-button>
              <el-button v-if="savaVisible" type="primary" @click.native="submitForm"
                :loading="addLoading">保存修改</el-button>

              <el-button v-if="syncVisible" type="success" @click.native="handleSync"
                :loading="addLoading">同步钉钉部门</el-button>

              <el-button v-if="deleteVisible" type="danger" @click.native="handleDel"
                :loading="addLoading">删除</el-button>

            </el-form-item>
          </el-form>
        </div>

        <div class="box2" v-if="addSubDivVisible">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="部门名称" prop="Name">
              <el-input v-model="ruleForm.Name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-if="savaVisible" type="primary" @click.native="submitForm"
                :loading="addLoading">保存修改</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { addDepartment, editDepartment, removeDepartment, syncDingDingDepartment } from '../../api/modules/department';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
        name: "",
      },
      editVisible: false,
      addVisible: false,
      addLoading: false,
      addSubVisible: false,
      savaVisible: false,
      addSubDivVisible: false,
      syncVisible: false,
      deleteVisible: false,
      ruleForm: {
        Id: 0,
        OrderSort: 0,
        PidArr: [],
        CreateBy: "",
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: true,
        SchId: "",
        SchType: "",
        ThirdPartySchoolId: "",
        Address: "",
        DeptOrgType: ""
      },
      rules: {
        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ]
      },
      CurrentDepartment: {}
    };
  },
  methods: {

    submitSubForm() {
      this.editVisible = false;
      this.addSubDivVisible = true;
      this.savaVisible = true;
      this.ruleForm.Name = '';
      this.ruleForm.Id = 0;
    },

    treeNodeClick(data, node, component) {
      this.CurrentDepartment = data
      this.addSubDivVisible = false;
      this.ruleForm.Name = '';
      this.ruleForm.Id = 0;

      if (data.schType == "DingDing") {
        this.syncVisible = true;
      } else {
        this.syncVisible = false;
      }

      if (data.deptOrgType == "school") {
        this.deleteVisible = false;
      } else {
        this.deleteVisible = true;
      }

      if (data.value == '') {
        this.editVisible = false;
        this.addVisible = false;
        this.addSubVisible = false;
        this.savaVisible = false;

      } else if (data.deptOrgType == "school") {

        this.editVisible = true;
        this.addVisible = true;
        this.addSubVisible = false;
        this.savaVisible = false;
        this.ruleForm.DeptOrgType = "grade";

      }
      else if (data.deptOrgType == "grade") {

        this.editVisible = true;
        this.addSubVisible = true;
        this.addVisible = false;
        this.savaVisible = true;

        this.ruleForm.DeptOrgType = "class";
        this.ruleForm.Name = this.CurrentDepartment.label;
        this.ruleForm.Id = this.CurrentDepartment.value;

      }
      else if (data.deptOrgType == "class") {
        this.editVisible = true;
        this.savaVisible = true;
        this.addSubVisible = false;
        this.addVisible = false;
        this.ruleForm.Name = this.CurrentDepartment.label;
        this.ruleForm.Id = this.CurrentDepartment.value;
      } else {
        this.editVisible = true;
        this.savaVisible = true;
        this.addSubVisible = false;
        this.addVisible = false;
        this.ruleForm.Name = this.CurrentDepartment.label;
        this.ruleForm.Id = this.CurrentDepartment.value;
      }
    },

    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    //新建部门
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;

            let para = Object.assign({}, this.ruleForm);

            if (para.Id > 0) {

              para.SchId = this.CurrentDepartment.schId;
              para.SchType = this.CurrentDepartment.schType;
              para.DeptOrgType = this.CurrentDepartment.deptOrgType;
              para.CodeRelationship = this.CurrentDepartment.codeRelationship;
              para.Pid = this.CurrentDepartment.Pid;

              para.ModifyTime = util.formatDate.format(
                new Date(),
                "yyyy-MM-dd hh:mm:ss"
              );

              editDepartment(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["ruleForm"].resetFields();

                  this.$refs.child.refreshMethod();

                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {

              para.SchId = this.CurrentDepartment.schId;
              var str = this.CurrentDepartment.codeRelationship.slice(0, -1);
              const arr = str.split(",");
              arr.push(this.CurrentDepartment.value);
              para.PidArr = arr;
              para.CodeRelationship = para.PidArr.join() + ",";
              para.Pid = para.PidArr.pop();

              para.CreateTime = util.formatDate.format(
                new Date(),
                "yyyy-MM-dd hh:mm:ss"
              );
              para.ModifyTime = para.CreateTime;
              para.IsDeleted = false;

              var user = JSON.parse(window.localStorage.user);

              if (user && user.uID > 0) {
                para.CreateId = user.uID;
                para.CreateBy = user.uRealName;
              }
              addDepartment(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["ruleForm"].resetFields();

                  this.$refs.child.refreshMethod();

                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //删除
    handleDel() {
      let row = this.CurrentDepartment;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.addLoading = true;
          //NProgress.start();
          let para = { id: row.value };
          removeDepartment(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.addLoading = false;
              return;
            }
            this.addLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.$refs.child.refreshMethod();
          });
        })
        .catch(() => { });
    },

    //同步钉钉部门
    handleSync() {
      let row = this.CurrentDepartment;
      if (!row) {
        this.$message({
          message: "请选择要同步的数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认同步该部门吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.addLoading = true;
          let para = { id: row.value, type: 1 };
          syncDingDingDepartment(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.addLoading = false;
              return;
            }
            this.addLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "同步成功,请刷新页面。",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.rightContainer {
  display: flex;
  /* 使用Flexbox布局 */
  flex-direction: column;
  /* 垂直排列 */
}

.box1 {
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  /* 下边距让Box 1和Box 2有间隔 */
}

.box2 {
  padding: 10px;
}
</style>
